<template lang="pug">
	.app.flex-row.align-items-center
		.container
			b-row.justify-content-center
				b-col(md='8' lg="6")
					b-card-group
						b-card.mb-0.p-4(no-body)
							b-card-body
								loginForm

						b-card.mb-0.text-white.bg-primary.py-5(no-body)
							b-card-body.text-center
								div
									h2(style="white-space:nowrap;") Регистрация
									small.d-block
										| Вы сможете регистрироваться на наши оффлайн и онлайн мероприятия, читать новости и многое другое.
									b-button.active.mt-3(variant='primary' to='/register') Зарегистрироваться!

</template>

<script>
	import loginForm from './components/loginForm.vue';

	export default {
		name: 'MyCadfemLogin',
		data: () => ({}),
		components: { loginForm },
	}
</script>
